import { FC } from "react";
import { Outlet } from "react-router-dom";
import { ThemeProvider } from "./theme";
import { AnalyticsProvider } from "./analytics";
import { NotificationProvider } from "@/context/NotificationContext";

export const Providers: FC = () => {
  return (
    <ThemeProvider>
      <AnalyticsProvider>
        <NotificationProvider>
          <Outlet />
        </NotificationProvider>
      </AnalyticsProvider>
    </ThemeProvider>
  );
};
